<template>
  <div class="page">
    <div class="header">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: .5vw">
        <div style="font-size: 4vw">我的积分</div>
        <div class="rule" @click="$router.push('/clerk/signInRule')">规则</div>
      </div>
      <div style="display: flex; align-items: center;">
        <div class="points" v-if="clerkPoint">{{divide100(clerkPoint)}}</div>
        <div @click="$router.push('/clerk/signInDetail')">
          明细
          <img src="/static/images/1508/arrow.png" style="width: 1.4vw; height: 2.6vw"/>
        </div>
      </div>
    </div>

    <div class="module">
      <div style="position: relative;">
        <div class="continus" >{{signInDays!=0? '已连续' : ''}}签到{{signInDays}}天</div>
        <div class="tips">再连续签到{{10-signInDays%10}}天，额外奖励50积分</div>
        <div class="signBtn" @click="signBtn" :style="todayIsSignIn? 'color: #B3B3B3; background: #F5F5F5' : ''">
          <img v-if="todayIsSignIn" src="/static/images/1508/true.png" style="width: 3.4vw; height: 2.3vw"/>
          {{ todayIsSignIn? '已签到' : '立即签到' }}
        </div>
      </div>
      <div class="dayList">
        <div v-for="(item, index) in currentWeekSignInLogList" :key="index" class="everyDay">
          <div class="core" :style="item.isSignIn? 'background: #379FFF; color: #fff' : ''">
            <div class="reward">+{{divide100(item.changeAmount)}}</div>
            <div style="width: 48.17%">
              <div class="square">
                <img v-if="!item.isSignIn" src="/static/images/1508/awardIcon.png" class="rewardImg"/>
                <img v-else src="/static/images/1508/true2.png" class="rewardImg"/>
              </div>
            </div>
          </div>
          <div class="data" :style="formatDate(item.createTime)==formatDate(new Date())? 'color: #333' : ''">{{formatDate(item.createTime)==formatDate(new Date())?'今天':formatDate(item.createTime)}}</div>
        </div>
      </div>
    </div>

    <div class="exchange">
      <div class="tab">
        <div class="tabItem" :class="{active: tabIndex === 0}" @click="tabClick(0)">
          积分兑换
          <div class="lineBlock" v-if="tabIndex === 0"></div>
        </div>
        <div class="tabItem" :class="{active: tabIndex === 1}" @click="tabClick(1)">
          兑换记录
          <div class="lineBlock" v-if="tabIndex === 1"></div>
        </div>
      </div>
      <div class="list" v-if="tabIndex===0">
        <van-list
            v-model="pointPrize.loading"
            :finished="pointPrize.finished"
            finished-text="没有更多了"
            @load="getPointPrize"
            offset="50"
        >
          <div v-for="(item, index) in pointPrize.list" :key="index" class="listItem">
            <img :src="getPrizeImage(item.action, item)" class="prizeImg" v-if="getPrizeImage(item.action, item)">
            <div class="middle">
              <div class="title">{{item.name}}</div>
              <div class="use">{{item.description}}</div>
              <!--            <div class="valid">{{item.text2}}</div>-->
            </div>
            <div class="right">
              <div class="price">
                <img src="/static/images/1508/awardIcon.png"/>
                <div>{{divide100(item.pointCost)}}</div>
              </div>
              <div class="exchangeBtn" @click="exchangeBtn(item)">兑换</div>
            </div>
            <img src="/static/images/1508/line.png" class="divideLine"/>
          </div>
        </van-list>
      </div>
      <div class="list" v-if="tabIndex===1">
        <van-list
            v-model="pointsExchangeLog.loading"
            :finished="pointsExchangeLog.finished"
            finished-text="没有更多了"
            @load="getPointsExchangeLog"
            offset="50"
        >
          <div v-for="(item, index) in pointsExchangeLog.list" :key="index" class="listItem" >
            <img :src="getPrizeImage(item.action, item)" class="prizeImg" v-if="getPrizeImage(item.action, item)">
            <div class="middle">
              <div class="title">{{item.name}}</div>
              <div class="use">{{item.description}}</div>
            </div>
            <div class="right">
              <div v-if="item.action==='user_balance_exchange_code'">
                <span v-if="item.prizeInfo.isUsed" style="color: #B3B3B3;">用户已兑换</span>
                <div class="exchangeBtn" style="padding: 0 2.5vw;" v-else @click="copyCode(item)">复制兑换码</div>
              </div>
              <div v-if="item.action==='impression_order'" style="color: #B3B3B3;">
                <span v-if="item.status==='unissued'">待发放</span>
                <span v-if="item.status==='issued'">已发放</span>
                <span v-if="item.status==='revoke_application'">撤销申请</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-popup v-model="signInShow">
      <div class="popupShow">
        <div class="succeed">签到成功</div>
        <div class="text">今日签到<span style="color: #F49E34" v-if="signIn.point">+{{divide100(signIn.point)}}积分</span>,已连续签到{{signIn.signInDays}}天</div>
        <div class="confim" @click="close">确定</div>
      </div>
    </van-popup>
    <van-dialog v-model="exchangeModel.show" title="兑换优惠券" confirmButtonText="兑换" show-cancel-button @confirm="exchangeEvent" @cancel="dialog.show = false">
      <div style="display: flex;margin-left: 20px">
        <img style="width: 16vw;height: 16vw;margin-right: 1.9vw;" :src="getPrizeImage('impression_order', exchangeModel.item)" >
        <div style="margin-top: 20px;color: #333333;font-weight: bold;font-size: 4vw;margin-bottom: 2vw;">{{exchangeModel.title}}</div>
      </div>
      <van-field v-model="exchangeModel.userId" type="number" placeholder="请先填写兑换用户ID" label="指定用户ID" />
    </van-dialog>
  </div>
</template>

<script>

import Vue from 'vue';
import {Popup, Dialog, Toast, List} from 'vant';
import {signIn, signInInfo} from "../../../api/clerk/clerk-points-log";
import {handlePromise} from "@/libs/util";
import Decimal from 'decimal.js';
import moment from 'moment';
import {getPointPrizeList, exchangePrize} from "../../../api/clerk/clerk-point-prize";
import {pointsExchangeLogList} from "../../../api/clerk/clerk-points-exchange-log";
Vue.use(Popup)
    .use(Dialog)
    .use(List)



export default {
  name: "Sign-in",

  data(){
    return {
      tabIndex: 0,
      issignIn: false,
      signInShow: false,
      dialog: {
        show: false,
        title: null
      },
      signIn:{
        signInDays:null,
        point:null
      },
      clerkPoint:null,
      signInDays:null,
      todayIsSignIn:null,
      currentWeekSignInLogList:[],
      pointPrize:{
        id:null,
        action:null,
        pageNo: 1,
        pageSize: 10,
        list:[],
        total: null,
        loading: false,
        finished: false,
      },
      pointsExchangeLog:{
        pageNo: 1,
        pageSize: 10,
        list:[],
        total: null,
        loading: false,
        finished: false,
      },
      loading: false,
      userId: null,
      exchangeModel: {
        show:false,
        title:null,
        action:null,
        id: null,
        userId: null,
        item: null,
      }

    }
  },

  methods:{
    getPrizeImage(action, item) {
      if (action === 'user_balance_exchange_code') {//用户余额兑换码
        return '/static/images/1508/red_packet.png';
      } else if (action === 'impression_order') {//印象单
        return '/static/images/1508/order.png';
      } else if (action === 'clerk_avatar_frame') {//店员头像框
        return item.prizeInfo.avatarFrameUrl;
      } else if (action === 'order_coupon') {//优惠券
        return '/static/images/1508/coupon.png';
      }
    },

    /** 格式化日期 */
    formatDate (date, format) {
      if (!date) {
        return ''
      }
      if (!format) {
        format = 'MM/DD'
      }
      return moment(date).format(format)
    },
    multiply100(amount) {
      return Decimal.mul(amount, 100).toNumber()
    },
    divide100(amount) {
      return Decimal.div(amount, 100).toNumber()
    },
    tabClick(val){
      this.tabIndex = val
      if( this.pointsExchangeLog.total != null){
        return
      } else {
        this.getPointsExchangeLog(true)
      }
    },

    close(){
      this.signInShow = false
    },

    exchangeBtn(item){
      this.exchangeModel = {show: false, title: null, id: null, userId: null, action: null, item: null,}
      this.exchangeModel.item = item
      this.exchangeModel.id = item.id
      this.exchangeModel.title = item.name
      this.exchangeModel.action = item.action
      if (item.action==='order_coupon'){
        this.exchangeModel.show = true
      }else {
        this.exchangeEvent()
      }
    },
    exchangeEvent() {
      if (this.exchangeModel.action==='order_coupon'){
        if (!this.exchangeModel.userId){
          return Toast('请输入用户ID');
        }
        if (!/^\d+$/.test(this.exchangeModel.userId)){
          return Toast('请输入正确的用户ID');
        }
      }
      Dialog.confirm({
        title: '确认要兑换 ' + this.exchangeModel.title + ' 吗',
      }).then(() => {
        Toast.loading({mask: true, message: '兑换中...'})
        handlePromise(exchangePrize(this.exchangeModel.id, this.exchangeModel.userId), (data) => {
          Toast.clear()
          this.clerkPoint = data.clerkPoint
          this.getPointsExchangeLog(true);
          Toast('兑换成功')
        }, (data) => {
          Toast.clear()
          Dialog.alert({title: '兑换失败', message: data.msg})
        })
      });

    },

    copyCode(item){
      let input = document.createElement("input");
      input.value = item.prizeInfo.code;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      Toast('复制成功')
    },

    //签到
    signBtn(){
      if(this.todayIsSignIn){ return }
      Toast.loading({
        mask: true,
        message: '签到中...'
      })
      handlePromise(signIn(), (data) => {
        Toast.clear()
        this.issignIn = true
        this.signInShow = true
        this.signIn.signInDays=data.signInDays
        this.signIn.point=data.changeAmount
        this.getSignInInfo(false)
      },(data)=>{
        Toast.clear()
        Dialog.alert({title: '签到失败', message: data.msg})
      })
    },
    //积分兑换记录
    getPointsExchangeLog(resetFirstPage){
      this.pointsExchangeLog.loading = true
      // 重置为首页
      if (resetFirstPage) {
        this.pointsExchangeLog.pageNo = 1
      }
      // 清空数据
      if (this.pointsExchangeLog.pageNo == 1) {
        this.pointsExchangeLog.list = [];
      }
      handlePromise(pointsExchangeLogList(null,null,this.pointsExchangeLog.pageNo,this.pointsExchangeLog.pageSize), (data) => {
        this.pointsExchangeLog.list = this.pointsExchangeLog.list.concat(data.list)
        this.pointsExchangeLog.total = data.total
        this.pointsExchangeLog.pageNo++
        this.pointsExchangeLog.finished = !data.hasNextPage
        this.pointsExchangeLog.loading = false
      },(data)=>{
        this.pointsExchangeLog.finished = true;
        this.pointsExchangeLog.loading = false
        Dialog.alert({title: '加载兑换记录失败', message: data.msg})
      })
    },
    //积分奖品
    getPointPrize(resetFirstPage){
      // 重置为首页
      if (resetFirstPage) {
        this.pointPrize.pageNo = 1
      }
      // 清空数据
      if (this.pointPrize.pageNo == 1) {
        this.pointPrize.list = [];
      }
      handlePromise(getPointPrizeList(null,null,this.pointPrize.pageNo,this.pointPrize.pageSize), (data) => {
        this.pointPrize.list = this.pointPrize.list.concat(data.list)
        this.pointPrize.total = data.total
        this.pointPrize.pageNo++
        this.pointPrize.finished = !data.hasNextPage
        this.pointPrize.loading = false
      },(data)=>{
        this.pointPrize.finished = true;
        this.pointPrize.loading = false
        Dialog.alert({title: '加载奖品失败', message: data.msg})
      })
    },
    getSignInInfo(isLoading){
      if (isLoading){
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
      }
      handlePromise(signInInfo(), (data) => {
        Toast.clear()
        this.clerkPoint = data.clerkPoint
        this.signInDays = data.signInDays
        this.todayIsSignIn = data.todayIsSignIn
        this.currentWeekSignInLogList = data.currentWeekSignInLogList
      },(data)=>{
        Toast.clear()
        Dialog.alert({title: '加载失败', message: data.msg})
      })
    }
  },
  mounted() {
    this.getSignInInfo(true)
    this.getPointPrize()
    // this.getPointsExchangeLog()
  }
}
</script>

<style scoped lang="less">
.page{
  position: relative;
  background: #F8F8F8;
  height: 100%;
  padding: 4.4vw 4vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  &:after{
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(180deg, #379FFF 60%, rgba(55,159,255,0));
    height: 92.6vw;
    z-index: -1
  }

  .header{
    color: #fff;
    margin-bottom: 3.75vw;
    font-size: 3.5vw;

    .points{
      font-size: 6.2vw;
      margin-right: 5.8vw;
    }

    .rule{
      background: rgba(0, 0, 0, .1);
      padding: 1.6vw 3.9vw 1.7vw;
      border-radius: 222px;
      line-height: 1;
    }
  }

  .module{
    background: #fff;
    border-radius: 2.1vw;
    padding: 3.8vw 2.7vw 6.4vw;
    margin-bottom: 2.8vw;

    .continus{
      font-size: 4vw;
      color: #333;
      font-weight: bold;
      margin-bottom: 1vw;
    }

    .tips{
      color: #333;
      font-size: 3.2vw;
    }

    .signBtn{
      position: absolute;
      top: 50%;
      border-radius: 222px;
      right: 0;
      background: #379FFF;
      font-size: 3.2vw;
      color: #fff;
      transform: translateY(-50%);
      padding: 0 4.8vw;
      height: 8.2vw;
      line-height: 8.2vw;
    }

    .dayList{
      margin-top: 3.9vw;
      display: flex;

      .everyDay{
        width: 13.42%;
        margin-right: 1%;

        .core{
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          background: #F5F5F5;
          border-radius: 1.1vw;
          padding: 2.15vw 0 2.5vw;
          color: #333;

          .reward{
            margin-bottom: 1.4vw;
            line-height: 1;
            font-size: 3.2vw;
          }

          .square{
            position: relative;
            padding-bottom: 100%;

            .rewardImg{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 0;
              width: 100%;
              //height: 100%;
            }
          }
        }

        .data{
          margin-top: 1.55vw;
          font-size: 2.9vw;
          text-align: center;
          color: #808080;
          line-height: 1;
        }

        &:last-child{
          margin-right: 0;
        }
      }
    }
  }

  .exchange{
    background: #fff;
    border-radius: 2.1vw;
    min-height: 50vw;
    color: #000;
    display: flex;
    flex-direction: column;

    .tab{
      display: flex;
      justify-content: space-evenly;
      padding: 0 5.4vw;

      .tabItem{
        font-size: 4vw;
        color: #B3B3B3;
        padding: 3.5vw 0;
        position: relative;

        &.active{
          color: #333;
          font-weight: bold;
        }

        .lineBlock{
          height: .9vw;
          width: 6.5vw;
          background: #379FFF;
          border-radius: 222px;
          position: absolute;
          left: 50%;
          top: 75%;
          transform: translateX(-50%)
        }
      }
    }

    .list{
      //margin-top: 2.5vw;
      //overflow-y: auto;
      padding: 2.5vw 3.6vw;
      min-height: 0;

      .van-list{
        overflow-y: auto;
        height: 100%;
      }

      .listItem{
        display: flex;
        margin-bottom: 1.9vw;
        position: relative;
        padding: 2.2vw 5.2vw 2.2vw 1.8vw;
        background: #FAFAFA;
        border-radius: 2.3vw;

        &:last-child{
          margin-bottom: 0
        }

        .prizeImg{
          width: 16vw;
          height: 16vw;
          margin-right: 1.9vw;
        }

        .middle{
          line-height: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          max-width: 38vw;

          .title{
            color: #333333;
            font-weight: bold;
            font-size: 4vw;
            margin-bottom: 2vw;
          }

          .use{
            margin-bottom: 1.3vw;
          }

          .use,
          .valid{
            font-size: 3.2vw;
            color: #808080;
          }
        }

        .right{
          font-size: 3.2vw;
          margin-left: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .price{
            color: #333;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1.3vw;

            img{
              width: 3.4vw;
              height: 3.4vw;
              margin-left: 1vw;
            }
          }

          .exchangeBtn{
            padding: 0 4.5vw;
            height: 7.4vw;
            line-height: 7.4vw;
            color: #fff;
            background: #379FFF;
            border-radius: 222px;
          }
        }

        .divideLine{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 24vw;
          width: .3vw;
          height: 18.8vw;
        }
      }
    }
  }

  /deep/.van-popup{
    background: none;
  }

  .popupShow{
    width: 72.5vw;
    height: 81.6vw;
    background: url("/static/images/1508/popupBg.png");
    background-size: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1;
    padding-top: 42vw;
    box-sizing: border-box;

    .succeed{
      font-size: 5.3vw;
      color: #141414;
      font-weight: bold;
      margin-bottom: 6.8vw;
    }

    .text{
      font-size: 3.7vw;
      color: #666666;
      margin-bottom: 6.8vw
    }

    .confim{
      background: #379FFF;
      font-size: 3.7vw;
      color: #fff;
      border-radius: 222px;
      width: 28.1vw;
      text-align: center;
      height: 9.7vw;
      line-height: 9.7vw
    }
  }
}

</style>